import { downloadAs } from '@utils/utils';
import { useQuery } from 'react-query';
import { downloadMultipleCommentsTemplate, getCommentTemplateList } from './commentApis';

export enum CommentQueryKeys {
  GET_COMMENT_LIST = 'getCommentTemplateList',
}

export const useCommentTemplateList = () => (
  useQuery(CommentQueryKeys.GET_COMMENT_LIST, async () => (await getCommentTemplateList()).data)
);

export const useMultipleCommentsExcelDownload = () => useQuery(
  ['downloadMultipleCommentsTemplate'],
  downloadMultipleCommentsTemplate,
  {
    enabled: false,
    onSuccess: (resp) => {
      downloadAs(
        resp.data,
        'multiple_comments_template.xlsx',
        'application/vnd.ms-excel',
      );
    },
  },
);
